import axios from 'axios';
import { CurrencyGetAllResponse } from '../types';

class CurrencyService {
  getAll = () => axios.get<CurrencyGetAllResponse>('/currencies');
}

export const currencyService = new CurrencyService();
